export default "__VITE_ASSET__1575d00f__"